
import { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ShareIcon from "@mui/icons-material/Share";
import { axiosInstance } from "../../utility/apiInstance";


import {
  TextField,
  Button,
  IconButton,
  Box,
  useMediaQuery,
} from "@mui/material";
import toast from "react-hot-toast";
import { useSearchParams, useNavigate } from "react-router-dom";

import TabularViewTraclist from "../../components/TabularViewTraclist";
import AirEventTimeLine from "../../components/AirTracking/AirEventTimeLine";
import AirTrackingHeading from "../../components/AirTracking/AirTrackingHeader";
import { FlagType } from "../../components/TabularViewofFlagList";

const defaultTheme = createTheme();

interface Milestone {
  etd: string;
  eta: string;
  status: number;
  milestone: string;
  origin?: string;
  station?: string;
  date: string;
}

const AwbTrackingPage = () => {

  const [searchparams] = useSearchParams();
  const navigate = useNavigate();
  const params = searchparams.get("trackingId");
  const [milestones, setMilestones] = useState<Milestone[]>([]);
  const [firstMilestones, setFirstMilestones] = useState<any[]>([]);
  const [lastMilestones, setLastMilestones] = useState<any[]>([]);

  const [trackList, setTrackList] = useState(null) as any;
  const [publicUrl, setPublicUrl] = useState(null) as any;
  const [showBox, setShowBox] = useState(false);
  const [status, setStatus] = useState();
  const [dialogIndex, setdialogIndex] = useState<null | number>(null);
  const [flags, setFlags] = useState<FlagType[]>([]);
  const [tabularViewData, settabularViewData] = useState({
    events: [],
    first: [],
    last: []
  });

  const handleRedirect = () => {
    navigate("/tracking-management");
  };

  useEffect(() => {
    awsTrackedList();
    async function awsTrackedList() {
      try {
        const response = await axiosInstance.get(
          `/api/v1/awb-tracked-list/${params}`
        );
        if (response.data.success) {
          setFlags(response?.data?.data?.flag);
          setTrackList(response.data.data);
          setMilestones(response.data.data.events);
          setFirstMilestones(response.data.data.first);
          setLastMilestones(response.data.data.last);
          setStatus(response.data.data.events.status);
        }
      } catch (error: any) {
        const apiError =
          error?.response?.data?.error || "Something went wrong.";
        setTimeout(() => {
          toast.dismiss();
          toast.error(apiError);
        }, 500);
        handleRedirect();
      }
    }
    getTablurViewTrackDetail();
  }, [params]);

  const handleCopy = (event: any) => {
    navigator.clipboard.writeText(publicUrl);
    toast.success("URL copied Succesfully!");
    setShowBox(false);
  };

  const handleShareIconClick = async () => {
    setShowBox(!showBox);
    try {
      const { data } = await axiosInstance.get(
        `/api/v1/awb-tracked-list/generate-public-link/${params}`
      );
      setPublicUrl(data?.data?.publicUrl);
    } catch (error) { }
  };

  const getTablurViewTrackDetail = async () => {
    try {
      const response = await axiosInstance.get(
        `/api/v1/awb-tracked-list/tabular-view/${params}`
      );
      let { status, flightsEtdEta, events, first, last } = response?.data?.data;
      events = events?.map((item: any) => ({ ...item, status: "event" }));
      const mergerdRes = [...status, ...flightsEtdEta, ...events] as any;
      settabularViewData({ events: mergerdRes, first, last });
    } catch (err) { }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="sharebox flex justify-end items-center mb-6">
        <h2 className="text-lg font-bold">Copy Link</h2>
        <figure className="relative  bg-yellow-500 w-[32px] h-[32px] rounded-full ml-3">
          <IconButton
            onClick={handleShareIconClick}
            className="relative z-index-2"
          >
            <ShareIcon className=" iconshare text-white-500 " />
          </IconButton>

          <span className="absolute inline-flex h-full w-full animate-ping rounded-full left-0 bg-yellow-400 opacity-75"></span>
        </figure>
      </div>

      <div className="min-h-screen">
        <div className="grid grid-cols-12 gap-x-4">
          {/* Section 3 - Top left */}

          <div className=" lg:col-span-7 col-span-12">
            <AirTrackingHeading trackList={trackList} />

            {/* Section 1 - Bottom left */}
            <div className="">
              {tabularViewData != null && (
                <TabularViewTraclist tabularViewData={tabularViewData} flags={flags} />
              )}
            </div>
          </div>

          {/* Section 2 - Right side (spans 2 rows) */}
          <div className=" lg:col-span-5 col-span-12">
            <div className="whiteBox whiteBoxCustom trackpadding">
              <div className="old_dashboard_title text-center">
                <h1 className="text-2xl  text-gray-700 mt-[-15px] mb-[10px]">
                  Events Timeline
                </h1>
              </div>

              <div className="trackNewScrollAIR">

                <AirEventTimeLine milestones={milestones} trackList={trackList} firstMilestones={firstMilestones} lastMilestones={lastMilestones} />

              </div>
            </div>
          </div>
        </div>
      </div>

      {showBox && (
        <div className="toolTips ">
          <Box
            sx={{
              position: "absolute",
              top: "140px",
              right: "60px",
              height: "70px",
              width: { xs: "100%", sm: "200px" },
              backgroundColor: "lightgray",
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              zIndex: 9999,
              padding: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)",
            }}
          >
            <TextField
              value={publicUrl}
              InputProps={{
                readOnly: true,
                style: { fontSize: "12px" },
              }}
              fullWidth
            />

            <Button
              onClick={handleCopy}
              sx={{
                ml: 1,
                height: "100%",
                fontSize: "12px",
                padding: "10px",
                color: "white",
                backgroundColor: "black",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Copy url
            </Button>
          </Box>
        </div>
      )}
    </ThemeProvider>
  );
};

export default AwbTrackingPage;
